import { ButtonComponent } from '@/components/commons'
import {
  CheckboxGroup,
  OptionCheckbox,
} from '@/components/commons/forms/CheckboxGroup'
import { CustomLink } from '@/components/commons/typography/CustomLinkt'
import { Text } from '@/components/commons/typography/Text'
import { Title } from '@/components/commons/typography/Title'
import { ModalPage } from '@/components/ui/modals/ModalPage.component'
import { BlockConnectionReason } from 'containers/profile/types/connections'
import { useEffect, useMemo, useState } from 'react'

interface BlockConnectionProps {
  showModal: boolean
  closeModal: () => void
  blockConnection: (reason: BlockConnectionReason) => void
}

const options = [
  {
    value: BlockConnectionReason.DO_NOT_KNOW,
    label: 'I do not know this user',
  },
  {
    value: BlockConnectionReason.HARASSING_USER,
    label: 'This user is harassing me',
  },
  {
    value: BlockConnectionReason.IMPERSONATING_USER,
    label: 'This user is impersonating me or someone else',
  },
  {
    value: BlockConnectionReason.VIOLATING_TERMS,
    label: (
      <span>
        I believe this user is violating the{' '}
        <CustomLink href="/terms" target="_blank">
          terms of service
        </CustomLink>
      </span>
    ),
  },
]

export const ModalBloackConnection = ({
  showModal,
  closeModal,
  blockConnection,
}: BlockConnectionProps) => {
  const [blockReason, setBlockReason] = useState<BlockConnectionReason | null>(
    null
  )

  const onChange = (option: OptionCheckbox<BlockConnectionReason>) => {
    setBlockReason(option.value)
  }

  const optionSelected = useMemo(() => {
    return options.find((option) => option.value === blockReason)
  }, [blockReason])

  useEffect(() => {
    if (!showModal) {
      setBlockReason(null)
    }
  }, [showModal])

  return (
    <ModalPage show={showModal} onClose={closeModal}>
      <div className="flex flex-column gap-4">
        <Title sizeClass="text-16" weightClass="font-bold">
          Block Connection
        </Title>
        <Text>Please select the reason why you want to block this user</Text>
        <CheckboxGroup
          options={options}
          onChange={onChange}
          optionSelected={optionSelected}
        />
        <div className="pt-12 flex justify-flex-end gap-16">
          <ButtonComponent
            label="Cancel"
            variation="secondary"
            size="xSmall"
            onClick={closeModal}
          />
          <ButtonComponent
            label="Remove"
            size="xSmall"
            onClick={() => blockConnection(blockReason!)}
            disabled={!blockReason}
          />
        </div>
      </div>
    </ModalPage>
  )
}
